import type { Circular } from './types';
import { newestFirst } from './circulars';
import { MOCK_CIRCULARS } from '@/data/circulars.mock';

// The ONLY place the site learns where circulars come from. When the CMS
// exists, replace the body with a fetch of GET /api/public/circulars and
// nothing else in the app needs to change.

// A circular is "new" for 30 days after it is published. The real API will make
// this decision on the server; the mock does it here so the badge is testable.
const NEW_FOR_DAYS = 30;

function isRecent(iso: string): boolean {
  const [y, m, d] = iso.split('-').map(Number);
  if (!y || !m || !d) return false;
  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const days = (today - Date.UTC(y, m - 1, d)) / 86_400_000;
  return days >= 0 && days <= NEW_FOR_DAYS;
}

export async function fetchCirculars(): Promise<Circular[]> {
  await new Promise((resolve) => setTimeout(resolve, 300)); // feel like a network call
  return newestFirst(MOCK_CIRCULARS).map((c) => ({ ...c, isNew: isRecent(c.publishedAt) }));
}
